/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeDupeAsync$Plain$Params {
  companyGuid: string;
  includeArchived?: boolean;
}

export function deDupeAsync$Plain(http: HttpClient, rootUrl: string, params: DeDupeAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, deDupeAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.query('includeArchived', params.includeArchived, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

deDupeAsync$Plain.PATH = '/userops/dedupe/{companyGuid}';
